'use strict';

/*angular.module('cloudxcmClientsApp')
  .controller('MainCtrl', function ($scope, $http, Auth, $translate) {
    $scope.$parent.titulo = $translate.instant('WELCOME');
    $scope.$parent.subtitulo = "";
    $scope.awesomeThings = [];
    $scope.getCurrentUser = Auth.getCurrentUser();
  });*/
